module.exports = __webpack_public_path__ + "img/understanding-physicalism-cover.2b1300ff.jpg";